import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importStandaloneUploadPaystubFlow = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "StandaloneUploadPaystubFlow" */
                '@perpay-web/fintech/components/screens/StandaloneUploadPaystubFlow/StandaloneUploadPaystubFlow'
            ),
    );
